var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUniBtcIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 14C27.75 6.40608 21.5939 0.25 14 0.25C6.40608 0.25 0.25 6.40608 0.25 14C0.25 21.5939 6.40608 27.75 14 27.75C21.5939 27.75 27.75 21.5939 27.75 14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3152 20.2L10.5702 19.758L9.92822 22.295L11.6732 22.737L12.3152 20.2Z",
    fill: "#664AED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3392 20.963L13.5942 20.521L12.9512 23.059L14.6962 23.501L15.3392 20.963ZM19.1902 5.733L17.4452 5.291L16.8032 7.828L18.5482 8.27L19.1902 5.733Z",
    fill: "#146AF4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1829 4.961L14.4379 4.52L13.7949 7.057L15.5399 7.499L16.1829 4.961Z",
    fill: "#664AED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1521 21.179L7.14111 18.893L7.68111 16.751L16.6931 19.037C17.4661 19.235 18.2391 18.805 18.4161 18.087C18.5931 17.369 18.1181 16.629 17.3451 16.43L11.7131 15.006L12.2531 12.863L17.8861 14.288C19.9181 14.807 21.1881 16.773 20.7021 18.661C20.2161 20.55 18.1731 21.687 16.1421 21.168L16.1521 21.179Z",
    fill: "#9077ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.538 7.50699L12.594 6.76199L9.37598 19.469L12.32 20.215L15.538 7.50699Z",
    fill: "#664AED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4752 15.07L10.8432 13.646L11.3832 11.503L17.0162 12.928C17.7892 13.127 18.5622 12.696 18.7392 11.978C18.9162 11.26 18.4412 10.521 17.6682 10.322L9.80518 8.33399L10.3452 6.19099L18.2102 8.17999C20.2422 8.69999 21.5122 10.665 21.0262 12.553C20.5402 14.442 18.4962 15.579 16.4652 15.06L16.4762 15.071L16.4752 15.07Z",
    fill: "#6FF1E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5219 7.497L12.5779 6.752L11.9629 9.182L14.9069 9.928L15.5219 7.497Z",
    fill: "#664AED"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUniBtcIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/uniBTCIcon.97f69def7ba88b3e30cc4ae31a1989d1.svg";